<div class="flex min-w-0 flex-col gap-1.5">
  <!-- Two questions: an ingredient the line may be dispensed as, or one exact box by Morion code. -->
  @if (isDrugSearch()) {
    <div class="flex min-w-0 flex-wrap gap-1">
      @for (entry of modes; track entry) {
        <button
          guaranteesToggle
          [pressed]="entry === mode()"
          size="sm"
          type="button"
          [matTooltip]="modeHintKey[entry] | translate"
          (click)="setMode(entry)"
        >
          {{ modeLabelKey[entry] | translate }}
        </button>
      }
    </div>
  }

  <!-- What was picked, shown as a value rather than as ghost placeholder text behind a live field. -->
  @if (chosen(); as pick) {
    <guarantees-picked-value
      [code]="pick.code ?? ''"
      [tooltip]="pick.name ?? ''"
      (cleared)="clear()"
      >{{ chosenName() }}</guarantees-picked-value
    >
  } @else {
    <guarantees-search-field
      cdkOverlayOrigin
      #origin="cdkOverlayOrigin"
      name="service"
      [placeholder]="placeholderKey() | translate"
      [value]="term()"
      [loading]="searching() || resolving()"
      (valueChange)="type($event)"
      (opened)="unfold()"
      (closed)="open.set(false)"
    ></guarantees-search-field>

    <!-- In an overlay, not in the flow: a list inside a dialog is cut off by the dialog's own scroll. -->
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayOpen]="open() && term().trim().length > 0"
      [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayWidth]="panelWidth()"
      [cdkConnectedOverlayMatchWidth]="true"
      (overlayOutsideClick)="open.set(false)"
      (detach)="open.set(false)"
    >
      <guarantees-option-list
        [style.width.px]="panelWidth() || null"
        [empty]="results().length === 0 && !searching()"
        [emptyMessage]="'guaranteeV2.message.noServiceResults' | translate"
        [loading]="searching()"
        [loadingMessage]="'guaranteeV2.message.searchingDictionary' | translate"
      >
        @for (item of results(); track item.key) {
          <li>
            <button
              guaranteesOption
              type="button"
              (click)="choose(item)"
            >
              <!-- Read beside the name; a substance row is its own code, so it is not printed twice. -->
              @if (showsCode(item)) {
                <span class="shrink-0 font-mono font-semibold text-neutral-700">{{ item.code }}</span>
              }
              <span class="min-w-0 flex-1 truncate text-neutral-600">{{ item.name }}</span>
            </button>
          </li>
        }
      </guarantees-option-list>
    </ng-template>
  }
</div>
